import {fixed2} from 'app/utils/fixed';

export const amountWithSign = function(amount: number, play_money = false): string {
    const res = fixed2(amount);
    return play_money
        ? `${res} PM`
        : `$${res}`;
};
